import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Switch as HeadlessUISwitch } from '@headlessui/react';
import useClassNames from '@medflex/hooks/useClassNames';

const SwitchStatusLabel = ({ enabled = false, className }) => {
  const { t } = useTranslation('components');
  const cn = useClassNames(() => ['ml-3', 'w-20', 'text-slate-500', className], [className]);

  return (
    <HeadlessUISwitch.Label as="span" className={cn}>
      {enabled ? t('Switch.activated') : t('Switch.deactivated')}
    </HeadlessUISwitch.Label>
  );
};

SwitchStatusLabel.defaultProps = {
  className: '',
};

SwitchStatusLabel.propTypes = {
  enabled: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

export default SwitchStatusLabel;
